import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface FlashMessageCSSStyle extends CRBTUICSSStyle
{
    getHeaderCssStyle(): object;
    getSubHeaderCssStyle(): object;
}

export class FlashMessageCSSStyleImpl extends CRBTUICSSStyleImpl implements FlashMessageCSSStyle
{
   getWrapperCSSStyle(): object
   {
        return {
            height: "100%",
            width: "100%"
        };
   }

   getSubHeaderCssStyle(): object{
    return {
        fontFamily: this.getResources().getFontFamily(),
        
    };
   }

   getHeaderCssStyle(): object{
    return {
        fontFamily: this.getResources().getFontFamily(),
        
    };
   }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagecss.tsx